export default __webpack_public_path__ + "static/media/41.9455b377.png";